var map = {
	"./sm_01_youtube.svg": "26d3",
	"./sm_02_fb.svg": "c580",
	"./sm_03_twit.svg": "6368",
	"./sm_04_insta.svg": "01c6",
	"./wechat_round.svg": "0600",
	"./xiaohongshu_round-df.svg": "6bef",
	"./xiaohongshu_round.png": "ee1f",
	"./xiaohongshu_round.svg": "cae6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5a83";